import api from "./api";

export const getChallenges = (page, params) => {
  return api.get("admin/Challenge", { params: { page: page, limit: 5, ...params} });
};

export const createChallenge = ({sqlCheck, sqlCheckProgress, untilDate, startDate, limit, name, prize, i18n }) => {
  return api.post("admin/challenge", { sqlCheck, sqlCheckProgress, untilDate, startDate, limit, name, prize, i18nContent: i18n });
};

export const updateChallenge = (uid, {untilDate, startDate, limit, name, prize, i18n}) => {
  return api.put(`admin/challenge/${uid}`, { untilDate, startDate, limit, name, prize, i18nContent: i18n });
};

export const enableChallenge = (uid, enabled) => {
  return api.post(`admin/challenge/${uid}/enable`, { enabled });
};

export const approveChallenge = (uid, approved) => {
  return api.post(`admin/challenge/${uid}/approval`, { approved });
};

export const getChallengesBySearch = (searchItem, search) => {
  return api.get(`admin/Challenge?searchItem=${searchItem}&search=${search}`);
};
    
export const getChallengesByOrder = (item, direction) => {
  return api.get(`admin/Challenge?order=${item}&direction=${direction}`);
};

export const getChallengeWinners = (uid, page) => {
  return api.get(`admin/challenge/${uid}/winners`, { page: page });
};
